<div
	class="au-assignee-select-container"
	(clickOutside)="removeFocus($event)"
	[class.disabled-menu]="!options?.length"
>
	<div class="assignee-select-trigger" [matMenuTriggerFor]="selectOptions">
		<!-- Should look like select input-->
		@if (type === 'input') {
			<input-type-select
				[blurEvent]="blurEvent"
				[label]="label"
				[placeholder]="placeholder"
				[value]="value"
				[loading]="!options?.length"
			></input-type-select>
		} @else {
			<input-type-block
				[blurEvent]="blurEvent"
				[placeholder]="placeholder"
				[value]="value"
			></input-type-block>
		}
		<!-- Should look like block type element-->
	</div>

	<mat-menu #selectOptions="matMenu" class="au-assignee-select-menu" yPosition="below">
		<assignee-options-list
			[options]="options"
			[disableTeamsSelection]="disableTeamsSelection"
			(selectionChange)="selectOption($event)"
		></assignee-options-list>
	</mat-menu>
</div>
